import { useContext } from 'react'

import { ActionIcon, Box } from '@mantine/core'
import dayjs from 'dayjs'

import { useAuth } from 'src/auth'
import Tag from 'src/components/DataDisplay/Tag/Tag'
import FilterMenu from 'src/components/Overlays/FiltersMenu/FilterMenu'
import { RecruitersContext } from 'src/context/RecruitersContext'
import IconCheckmark from 'src/icons/IconCheckmark'
import IconChevronLeft from 'src/icons/IconChevronLeft'

import {
  addWeek,
  calculateWeekDateRange,
  subtractWeek,
  bookingStatusOptions,
} from '../utils'

const CalendarHeader = ({
  calendarStartDate,
  calendarEndDate,
  setCalendarStartDate,
  setCalendarEndDate,
  selectedRecruiters,
  setSelectedRecruiters,
  selectedStatuses,
  setSelectedStatuses,
}) => {
  const recruiters = useContext(RecruitersContext)
  const { currentUser } = useAuth()
  const fullName = currentUser
    ? `${currentUser.firstName} ${currentUser.lastName}`
    : ''
  const isCurrentUserSelected = currentUser
    ? selectedRecruiters.includes(currentUser.employeeId)
    : false

  return (
    <div className="flex w-full flex-row items-center justify-between">
      <div className="grid w-full grid-cols-3 items-baseline justify-between gap-4 text-lg font-semibold text-doubleNickel-gray-900">
        <div>{dayjs(calendarStartDate).format('MMMM YYYY')}</div>
        <div className="flex flex-row items-center justify-center gap-4 text-sm font-medium text-doubleNickel-gray-600">
          <ActionIcon
            variant="subtle"
            color="gray"
            onClick={() => {
              const { startDate, endDate } = subtractWeek({
                start: calendarStartDate,
                end: calendarEndDate,
              })
              setCalendarStartDate(startDate)
              setCalendarEndDate(endDate)
            }}
          >
            <IconChevronLeft className="h-4 fill-none stroke-doubleNickel-gray-700" />
          </ActionIcon>
          <Box
            className="cursor-pointer rounded p-2 px-4 hover:bg-doubleNickel-gray-100"
            onClick={() => {
              const { startDate, endDate } = calculateWeekDateRange()
              setCalendarStartDate(startDate)
              setCalendarEndDate(endDate)
            }}
          >
            Today
          </Box>
          <ActionIcon
            variant="subtle"
            color="gray"
            onClick={() => {
              const { startDate, endDate } = addWeek({
                start: calendarStartDate,
                end: calendarEndDate,
              })
              setCalendarStartDate(startDate)
              setCalendarEndDate(endDate)
            }}
          >
            <IconChevronLeft className="h-4 rotate-180 fill-none stroke-doubleNickel-gray-700" />
          </ActionIcon>
        </div>
        <div className="ml-auto flex flex-row items-center gap-3">
          <span className="text-xs font-medium text-doubleNickel-gray-700">
            Suggested:
          </span>
          {currentUser && (
            <Tag
              clickable={true}
              onClick={() => {
                if (isCurrentUserSelected) {
                  setSelectedRecruiters(
                    selectedRecruiters.filter(
                      (id) => id !== currentUser.employeeId
                    )
                  )
                } else {
                  setSelectedRecruiters([
                    ...selectedRecruiters,
                    currentUser.employeeId,
                  ])
                }
              }}
              showCloseButton={false}
            >
              {isCurrentUserSelected && (
                <IconCheckmark className="h-3 w-3 fill-none stroke-doubleNickel-brand-400" />
              )}
              {fullName}
            </Tag>
          )}
          <FilterMenu
            filters={[
              {
                title: 'Recruiters',
                selected: selectedRecruiters,
                onChange: (value) => setSelectedRecruiters(value),
                options: recruiters ? [...recruiters] : [],
              },
              {
                title: 'Status',
                selected: selectedStatuses,
                onChange: (value) => setSelectedStatuses(value),
                options: bookingStatusOptions,
              },
            ]}
          />
        </div>
      </div>
    </div>
  )
}

export default CalendarHeader
